import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { PERMISSIONS } from '@lms/shared-types';
import { PageLoader } from '@lms/ui';
import { usePermissions } from '@/hooks/usePermissions';
import { api } from '@/lib/api';
import { contractSigningPath } from '@/lib/student-contract-gate';

const ALLOWED_PREFIXES = ['/mis-contratos', '/soporte', '/profile', '/acceso-denegado', '/403'];

function isContractGateAllowedPath(pathname: string): boolean {
  return ALLOWED_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}

interface PendingResponse {
  data: { id: string; pendingCount: number } | null;
}

export function ContractPendingGuard() {
  const { pathname } = useLocation();
  const { hasPermission } = usePermissions();
  const canViewContracts = hasPermission(PERMISSIONS.MIS_CONTRATOS_VER);

  const { data, isLoading } = useQuery({
    queryKey: ['student', 'contracts', 'pending'],
    queryFn: () => api<PendingResponse>('/student/contracts/pending'),
    enabled: canViewContracts,
    staleTime: 0,
  });

  if (!canViewContracts) {
    return <Outlet />;
  }

  if (isLoading) {
    return <PageLoader label="Verificando contratos…" />;
  }

  const pending = data?.data;
  if (pending && !isContractGateAllowedPath(pathname)) {
    return <Navigate to={contractSigningPath(pending.id)} replace />;
  }

  return <Outlet />;
}
